// production | test | develop
export const appEnvironment = "production";